/**
 * Security / privacy reassurance lines (Sam, Oct 12 2026).
 * Keep accurate to the code + Privacy Policy:
 * - ID: Stripe Identity; server keeps only verified flags + timestamp (stripeIdentity.js).
 *   Manual fallback photo is on our server until an ops decision, then deleted (manualIdReview.js).
 * - Payouts: Stripe Connect hosted onboarding; bank numbers never touch our servers.
 * - Card: Stripe Elements iframe; we only see brand + last 4.
 * - Privacy Policy says "We do not sell" (it DOES share with processors), so no "never shared".
 */
export const TRUST_ID_LINE =
  'Your ID photo and selfie go securely to Stripe, our verification partner. We only keep a note that you passed \u2014 never your ID images, name, or date of birth.';
export const TRUST_ID_MANUAL_LINE =
  'If you upload a photo of your ID instead, only our small review team sees it, and it\u2019s deleted as soon as it\u2019s reviewed.';
export const TRUST_PAYOUTS_LINE =
  'Payouts run through Stripe. Stripe verifies identity for payouts \u2014 we don\u2019t keep your ID files. Your bank details go straight to Stripe; we never see your full account number. Earners are never charged.';
export const TRUST_CARD_LINE =
  'Card details go to Stripe, not Sweet Listeners. We never store your full card number \u2014 only the last 4 digits so you can recognize it.';
export const TRUST_PRIVATE_LINE = 'Your info is private. We never sell your personal information.';
// Misty (Oct 12) balked at a business/EIN screen. US individual Connect accounts need
// name, address, DOB, SSN last 4 (Stripe may ask for the full SSN later); no EIN for individuals.
export const TRUST_INDIVIDUAL_LINE =
  'No business needed: choose \u201cI\u2019m an individual.\u201d Stripe asks for your name, address, birthday and usually the last 4 of your SSN because the law requires it to send you money. Stripe keeps it secure \u2014 we never see your SSN.';

export const STRIPE_SECURITY_URL = 'https://stripe.com/docs/security';
export const STRIPE_SECURITY_LINK_LABEL = 'How Stripe keeps your info safe';
